import { useContext, useEffect, useState } from "react";
import { UserContext } from "../contexts/user.context";
import { toast } from "react-toastify";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import walkieTalkieSound from "../assets/sounds/walkie-talkie-beeb.mp3";

export default function useWalkieTalkie() {
  const { t } = useTranslation();
  const { userData, socket } = useContext(UserContext);
  const [walkieTalkie, setWalkieTalkie] = useState<any[]>([]);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  // const [duration, setDuration] = useState<number | null>(null);

  const playSound = (src: string, onended?: () => void) => {
    const sound = new Audio(src);
    sound.play();
    sound.onended = onended || (() => {});
  };

  const playWalkieTalkie = (data: any) => {
    setIsPlaying(true);

    if (data.voice_note) {
      const voice_note = new Audio(data.voice_note);

      toast.info(
        <div
          className={`flex items-center gap-3 ${
            i18next.language === "en" ? "flex-row" : "flex-row-reverse"
          }`}
        >
          <div
            className={`flex flex-col gap-1`}
            dir={`${i18next.language === "en" ? "ltr" : "rtl"}`}
          >
            <p className="text-lg">
              {t("channel")}: {data.channel_name}
            </p>
            <p className="text-lg">
              {t("user")}: {data.user_name}
            </p>
          </div>
        </div>,
        {
          position: i18next.language === "en" ? "bottom-right" : "bottom-left",
          autoClose: data.duration * 1000,
          onClose: () => {
            setIsPlaying(false);
            voice_note.pause();
            setWalkieTalkie((prev) => prev.filter((_, index) => index !== 0));
          },
        }
      );

      playSound(walkieTalkieSound, () => {
        voice_note.play();
      });

      voice_note.onended = () => {
        setIsPlaying(false);
        playSound(walkieTalkieSound);
        // const filteredWalkieTalkies = walkieTalkie.filter(
        //   (walkie, index) => index !== 0
        // );
        // console.log("ended", filteredWalkieTalkies);
        setWalkieTalkie((prev) => prev.filter((_, index) => index !== 0));
      };
    }
  };

  const handleListen = (data: any) => {
    const mutedChannels = JSON.parse(
      localStorage.getItem("mutedChannels") || "[]"
    );
    if (
      userData[0]?.asdc_client_user_id != data?.user_id &&
      userData[0]?.user_channel_relationship
        ?.map((channel: any) => channel?.channel_id)
        ?.includes(data.channel_id) &&
      !mutedChannels.includes(data.channel_id)
    ) {
      setWalkieTalkie((prev) => [...prev, data]);
    }
  };

  // console.log("walkieTalkie", walkieTalkie);
  useEffect(() => {
    socket.on(
      // `walkieTalkie_${userData[0]?.asdc_client_user_id}`,
      `walkieTalkie`,
      handleListen
    );
    // return () => {
    //    socket.close();
    // };
  }, [t, userData]);

  useEffect(() => {
    if (walkieTalkie.length > 0 && !isPlaying) {
      playWalkieTalkie(walkieTalkie[0]);
    }
  }, [walkieTalkie]);
}
